import React from 'react';
import Logo from '../Logo';

export default function MarketingHeader() {
  return (
    <header className="site-header fixed inset-x-0 top-0 z-50">
      <div className="mx-auto flex h-20 max-w-7xl items-center px-4 sm:px-6 lg:px-8">
        <Logo />
      </div>
    </header>
  );
}